<template>
  <div>
    <DxPopup
      :visible="confirmDeliveryPopup"
      :close-on-outside-click="true"
      :show-close-button="true"
      class="DxPopup"
      :wrapper-attr="{
        class: 'albaran-popup samples-register-final-popup',
        'data-tour-id': 'samples-register-final-popup',
      }"
      width="730"
      height="auto"
      :title-template="'customTitle'"
      container=".dx-viewport"
      @hiding="hide"
    >
      <template #customTitle>
        <div class="custom-popup-title">
          <span class="fa-stack">
            <!-- <i class="fa-solid fa-shipping-fast fa-stack-2x"></i> -->
            <div class="icon-en-camino"></div>
          </span>
        </div>
      </template>

      <div class="popup-content">
        <!-- <h2>{{ $t('Thanks') }}</h2> -->
        <h4 class="popup-title">
          {{ $t('samplesRegister.saveDeliveryNoteCode') }}
        </h4>
        <h3 class="popup-subTitle">{{ invoiceCodeInfoPopUp }}</h3>

        <!-- Un H3 por cada respuesta -->
        <h3
          v-for="(item, idx) in respuestasAceptacionFiltradas"
          :key="
            item && item.CodPresupuesto ? item.CodPresupuesto : idx
          "
          class="popup-subTitle"
        >
          {{ item && item.CodPresupuesto }}
          <span :class="badgeClass(item && item.Respuesta)">
            {{ respuestaMsg(item && item.Respuesta) }}
          </span>
        </h3>

        <div class="popup-actions">
          <f7-button
            class="btn-secondary"
            data-tour-id="samples-register-final-popup-back-button"
            fill
            outline
            type="default"
            @click="confirmGoBack"
          >
            {{ $t('samplesRegister.backToLisiting') }}
          </f7-button>

          <f7-button
            class="btn-accept color-green margin-left"
            data-tour-id="samples-register-final-popup-pdf-button"
            fill
            outline
            type="default"
            @click="InvoiceDownload"
          >
            {{ $t('samplesRegister.downloadDeliveryNoteInPdf') }}
          </f7-button>
        </div>
        <p class="popup-note">
          {{ $t('deliveryMessage') }}
        </p>
      </div>
    </DxPopup>
  </div>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { mapState, mapActions } from 'vuex';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  name: 'AlbaranPopup',
  components: { DxPopup },
  computed: {
    respuestasAceptacionList() {
      const v = this.RespuestaAceptacion;
      if (Array.isArray(v)) return v;
      if (v && typeof v === 'object') return [v];
      return [];
    },
    respuestasAceptacionFiltradas() {
      return this.respuestasAceptacionList.filter(
        (it) => Number(it && it.Respuesta) === 2
      );
    },
    ...mapState('samplesRegisterModule', [
      'confirmDeliveryPopup',
      'invoiceCodeInfoPopUp',
      'idInvoice',
    ]),
    ...mapState('Offers', ['RespuestaAceptacion']),
  },
  beforeMount() {
    this.setCurrentRoute([
      {
        name: this.$t('SamplesList.orderList'),
        disabled: false,
        page: 'SamplesList',
        active: false,
      },
      {
        name: this.$t('Confirmed_SampleRegister'),
        disabled: false,
        page: 'SamplesConfirmation',
        active: true,
      },
    ]);
  },
  methods: {
    // Mapea el código de respuesta al mensaje
    respuestaMsg(code) {
      const c = Number(code);
      const map = {
        2: this.$t('offerAccepted'),
      };
      return Object.prototype.hasOwnProperty.call(map, c)
        ? map[c]
        : 'Respuesta desconocida.';
    },
    // Clase visual según OK (2) o error
    badgeClass(code) {
      return Number(code) === 2 ? 'textoAceptado' : 'textoError';
    },

    hide() {
      this.setConfirmDeliveryPopup(false);
    },
    async confirmGoBack() {
      try {
        this.$f7.preloader.show();
        this.$f7router.navigate(
          { name: 'SamplesList' },
          { animate: true, transition: 'f7-fade' }
        );
        setTimeout(() => {
          this.setPriceAlert(true);
        }, 5000);
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
        this.setRespuestaAceptacion([]);
        this.hide();
      }
    },
    async InvoiceDownload() {
      try {
        this.$f7.preloader.show();
        await this.generateInvoicePDF(this.idInvoice);
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
        this.hide();
        this.$f7router.navigate(
          { name: 'SamplesList' },
          { animate: true, transition: 'f7-fade' }
        );
      }
    },
    ...mapActions('samplesRegisterModule', [
      'setConfirmDeliveryPopup',
      'generateInvoicePDF',
      'setPriceAlert',
    ]),
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('Offers', ['setRespuestaAceptacion']),
  },
};
</script>

<style scoped>
.custom-popup-title {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: white;
  padding: 24px 10px 0 10px;
  font-size: 1.4rem;
  font-weight: bold;
  border-radius: 10px 10px 0 0;
}
.custom-popup-title .title-text {
  margin-left: 10px;
}
.popup-content {
  padding: 15px 25px 25px 25px;
  text-align: center;
  font-family: 'Arial', sans-serif;
  padding-top: 0;
}
.popup-content h2 {
  margin-bottom: 15px;
}
.details {
  margin: 20px 0;
  font-size: 0.95em;
  line-height: 1.4;
}
.popup-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.popup-subTitle {
  font-size: 1.2rem;
  margin-bottom: 20px;
  color: var(--Neutral-70, #3e3c44);
  font-weight: bold;
}
.popup-note {
  font-size: 13px;
  margin: 35px 30px 10px;
  color: var(--Neutral-70, #3e3c44);
}
.textoAceptado {
  color: #62903c;
  font-weight: 700;
}
.textoError {
  color: #cc3a3a;
  font-weight: 700;
}
.btn-accept {
  color: white;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  width: auto;
  padding: 16px;
  padding-top: 3px;
}
.btn-accept:hover {
  background: #00346a;
  transform: scale(1.05);
}
.icon-en-camino {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url('@/static/icons/en_camino.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 1;
}
.dx-popup-title {
  border-bottom: none !important; /* quita la barra */
}
.popup-title {
  color: var(--Neutral-70, #3e3c44);
  font-size: 16px;
  font-style: normal;
  margin-bottom: 15px;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
  white-space: pre-line;
}

.btn-secondary {
  background-color: white !important;
  color: #00346a !important;
  border: 1px solid #00346a !important;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 10px;
  width: auto;
  padding: 16px;
  padding-top: 2px;
}
.btn-secondary:hover {
  background: white;
  transform: scale(1.05);
}
</style>

<style>
.albaran-popup .dx-overlay-content {
  border-radius: 10px !important;
  overflow: hidden; /* asegura que el contenido respete el radio */
  width: 730px !important;
}
</style>
